import React from 'react';

import { Stat } from '../../design-system/components/desktop';
import { StatGrid, StatValue } from '../../design-system/patterns/console';
import { formatCurrency } from '../../utils/common';

/**
 * The buyer's KPI band: how big their collection is and what it is worth.
 *
 * The seller's dashboard opens with four numbers about their business. A buyer
 * got a bare tab bar, so the first thing they saw was a table. These are the
 * buyer's equivalent: the two facts they actually track about a collection.
 *
 * PORTFOLIO VALUE IS ALLOWED TO BE ABSENT, and that is deliberate.
 * `useCollectionSummary` returns `value: null` when it could not see the whole
 * collection in one request, because the alternative is a money figure that
 * silently counts some of their cards and presents itself as all of them. An
 * absent number is recoverable; a wrong one about what someone owns is not.
 *
 * It is a MARKET valuation, not what they paid, so the label says "at market"
 * and never "profit" or "worth". We hold no purchase prices for saved cards, so
 * any gain or loss figure here would be invented.
 */
export function BuyerStats({ count, value, complete, loading }) {
  return (
    <StatGrid>
      <Stat
        label="Cards in collection"
        value={<StatValue loading={loading}>{count == null ? 'No data' : count}</StatValue>}
      />
      <Stat
        label="Collection value at market"
        value={
          <StatValue loading={loading}>
            {value == null ? 'No data' : formatCurrency(value)}
          </StatValue>
        }
      >
        {!loading && value == null && complete === false ? (
          <span className="dsk-hint">Too many cards to total here</span>
        ) : null}
      </Stat>
    </StatGrid>
  );
}

export default BuyerStats;
